import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { authService } from '../services/api';

const EMPTY = { currentPassword: '', newPassword: '', confirm: '' };

function ChangePasswordDialog({ open, onClose }) {
  const { enqueueSnackbar } = useSnackbar();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const mismatch = form.confirm !== '' && form.newPassword !== form.confirm;
  const valid = form.currentPassword && form.newPassword.length >= 6 && form.newPassword === form.confirm;

  const close = () => {
    if (saving) return;
    setForm(EMPTY);
    onClose();
  };

  const submit = async () => {
    setSaving(true);
    try {
      await authService.changePassword({
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      enqueueSnackbar('Mot de passe modifié', { variant: 'success' });
      setForm(EMPTY);
      onClose();
    } catch (err) {
      const message = err.response && err.response.data && err.response.data.message;
      enqueueSnackbar(message || 'Erreur lors du changement de mot de passe', { variant: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="xs">
      <DialogTitle>Changer mon mot de passe</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
        <TextField
          label="Mot de passe actuel"
          type="password"
          value={form.currentPassword}
          onChange={(e) => setForm({ ...form, currentPassword: e.target.value })}
          autoFocus
          sx={{ mt: 1 }}
        />
        <TextField
          label="Nouveau mot de passe (6 caractères minimum)"
          type="password"
          value={form.newPassword}
          onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
        />
        <TextField
          label="Confirmer le nouveau mot de passe"
          type="password"
          value={form.confirm}
          onChange={(e) => setForm({ ...form, confirm: e.target.value })}
          error={mismatch}
          helperText={mismatch ? 'Les deux mots de passe ne correspondent pas' : ' '}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} disabled={saving}>Annuler</Button>
        <Button variant="contained" onClick={submit} disabled={!valid || saving}>
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChangePasswordDialog;
